export function Privacy({ supportEmail }: { supportEmail?: string }) {
  return (
    <article className="prose">
      <h1>Privacy Policy</h1>
      <p className="updated">
        This is a starter policy for ReleaseMachine and is not a substitute for legal
        review.
      </p>

      <h2>What we collect</h2>
      <p>
        When you place an order, we collect the information you submit about your song and
        your campaign — including your email address, artist name, song title, genre,
        description, and any lyrics, notes, or other details you choose to provide. We
        also receive payment confirmation from Stripe (we never see or store your card
        details ourselves).
      </p>

      <h2>How we use it</h2>
      <p>
        Your song information is used only to generate and deliver your campaign. It is
        processed by the infrastructure and AI providers necessary to fulfill your order —
        currently Cloudflare (hosting, storage, and queueing), Anthropic (AI generation),
        Stripe (payment), and Resend (email delivery). We do not sell your information,
        and we do not use your submissions to train our own or any third party's AI
        systems.
      </p>

      <h2>What we don't do</h2>
      <ul>
        <li>We don't log your full lyrics or notes in ordinary application logs.</li>
        <li>
          We don't share your song information with anyone beyond the providers listed
          above.
        </li>
        <li>We don't post anything to social media on your behalf.</li>
        <li>
          We don't require an account, so we don't build a profile of you across visits.
        </li>
      </ul>

      <h2>How long we keep it</h2>
      <p>
        Generated campaign files are retained for a limited period (see our storage
        retention note in the FAQ and Terms) to give you time to download them. Order
        records are kept as needed for payment, support, and legal recordkeeping purposes.
      </p>

      <h2>Your choices</h2>
      <p>
        Because there is no account system, your primary control is simply not submitting
        information you don't want processed. If you'd like a copy of your data deleted,
        contact us and we'll handle it manually.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy? Contact{" "}
        {supportEmail ? (
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        ) : (
          "our support team"
        )}
        .
      </p>
    </article>
  );
}
